<template>
  <div>
    <div id="one_map" ref="map"></div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: "bmap",
      type: String,
    },
    center:{
      default: [116.397428,39.90923],
      type: Array,
    },
    zoom: {
      default: 16,
      type: String,
    },
    "max-scale": {
      default: null,
      type: Number,
    },
    markers: {
      default: null,
      type: Array,
    },
    polyline: {
      default: null,
      type: Array,
    },
    enableZoom: {
      default: null,
      type: String,
    },
    bindtap: {
      default: null,
      type: Function,
    },
  },
  data() {
    return {
      map: null,
      mapApi: null,
      timer: null,
      markerObjs: [],
    };
  },
  created() {
    let config = this.$oneMap;
    if(config.center){
      this.center = config.center;
    };
    if(config.zoom){
      this.zoom = config.zoom;
    };
    if(config.map){
      this.type = config.map;
    };
    console.log(this.$oneMap)
  },
  mounted() {
    this.setMapType();
  },
  watch: {
    markers(markers) {
      this.mapApi.removeOverlays();
      markers.forEach((e) => {
        this.mapApi.addMarker(e);
      });
    },
    type(type) {
      this.$refs.map.innerHTML = ''
      this.setMapType(type);
    },
  },
  methods: {
    init() {
      this.timer = setTimeout(() => {
        if (!this.mapApi.getMap()) {
          clearTimeout(this.timer);
          this.init();
        } else {
          this.map = this.mapApi.getMap();
          this.$oneMap.getMap = ()=>{
            return this.map;
          }
          this.setMapBaseOptions();
        }
      }, 200);
    },
    setMapType() {
      switch (this.type) {
        case "bmap":
          if (this.$oneMap.bMap) {
            this.$oneMap.bMap.createMap();
            this.mapApi = this.$oneMap.bMap;
          }
          break;
        case "amap":
          if (this.$oneMap.aMap) {
            this.$oneMap.aMap.createMap();
            this.mapApi = this.$oneMap.aMap;
          }
          break;
        case "zmap":
          if (this.$oneMap.zMap) {
            this.$oneMap.zMap.createMap();
            this.mapApi = this.$oneMap.zMap;
          }
          break;
        default:
          //默认高德地图
          if (this.$oneMap.aMap) {
            this.$oneMap.aMap.createMap();
            this.mapApi = this.$oneMap.aMap;
          }
          break;
      }
      this.init();
    },
    setMapBaseOptions() {
      console.log(this)
      // if (this.center[0] && this.center[1]) {
      //   var point = new window.BMap.Point(116.404, 39.915); // 创建点坐标
      //   this.map.centerAndZoom(point, this.zoom*1 || 18);
      // }
      if (this.bindtap) {
        this.mapApi.on('click',this.bindtap)
      }
      if (this.markers.length > 0) {
        this.markers.forEach((e) => {
          this.mapApi.addMarker(e);
        });
      }
    },
  },
};
</script>

<style scoped>
#one_map {
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/package/index.vue